(function() {
  function isVizupModalOpen() {
    const vizupElements = document.querySelectorAll('[class*="vizup"], [id*="vizup"], iframe');
    for (const el of vizupElements) {
      const rect = el.getBoundingClientRect();
      const style = window.getComputedStyle(el);
      // If it's a fixed element taking up most of the screen, it's the modal
      if (style.position === 'fixed' && rect.height > window.innerHeight * 0.8 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
        return true;
      }
    }
    return false;
  }

  function updateCartBadgeOnly() {
    fetch(window.location.pathname + '?section_id=cart-icon-bubble')
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newBubble = doc.getElementById('cart-icon-bubble');
        const currentBubble = document.getElementById('cart-icon-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      });
  }

  function openThemeCartDrawer(productData) {
    if (isVizupModalOpen()) {
      // Just update the cart counter, don't open the visual popup
      updateCartBadgeOnly();
      return;
    }

    const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartDrawer) {
      if (productData && productData.items && productData.items.length > 0) {
        productData = productData.items[0];
      }
      
      const sections = cartDrawer.getSectionsToRender().map((s) => s.id).join(',');
      fetch(window.location.pathname + '?sections=' + sections)
        .then(res => res.json())
        .then(res => {
          const parsedState = Object.assign({}, productData || {}, res);
          cartDrawer.renderContents(parsedState);
        })
        .catch(e => console.error(e));
    }
  }

  // Intercept fetch requests
  const originalFetch = window.fetch;
  window.fetch = async function() {
    let hasSections = false;
    try {
      if (arguments[1] && arguments[1].body instanceof FormData) {
        if (arguments[1].body.has('sections')) {
          hasSections = true;
        }
      } else if (arguments[1] && typeof arguments[1].body === 'string') {
        if (arguments[1].body.includes('sections=')) {
          hasSections = true;
        }
      }
    } catch(e) {}
    
    const response = await originalFetch.apply(this, arguments);
    try {
      const url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] instanceof Request ? arguments[0].url : '');
      // Only trigger if it's an add to cart request and the theme isn't already handling it natively
      if ((url.includes('/cart/add.js') || url.includes('/cart/add')) && !hasSections) {
        if (response.ok) {
          response.clone().json().then(productData => {
            setTimeout(() => openThemeCartDrawer(productData), 100);
          }).catch(e => {
            setTimeout(() => openThemeCartDrawer({}), 100);
          });
        }
      }
    } catch(e) {
      console.error(e);
    }
    return response;
  };
})();